// extracted by mini-css-extract-plugin
module.exports = {"MainContainer":"Layout_MainContainer__37xCG"};